import { useEffect, useState } from 'react'

// Contract closes (including 16:15) advance without requiring a new quote.
export function useOptionSessionClock(enabled) {
  const [clock, setClock] = useState(Date.now)
  useEffect(() => {
    if (!enabled) return undefined
    let timer
    const refresh = () => {
      clearTimeout(timer)
      setClock(Date.now())
      timer = setTimeout(refresh, 60_000 - (Date.now() % 60_000) + 25)
    }
    refresh()
    window.addEventListener('focus', refresh)
    document.addEventListener('visibilitychange', refresh)
    return () => {
      clearTimeout(timer)
      window.removeEventListener('focus', refresh)
      document.removeEventListener('visibilitychange', refresh)
    }
  }, [enabled])
  return clock
}
